
import { Router } from '@angular/router';
import { ModalService } from './../../services/modal.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-modal',
  templateUrl: './app-modal.component.html',
  styleUrls: ['./app-modal.component.scss']
})
export class AppModalComponent implements OnInit {

  constructor(public ModalService :ModalService, private router: Router) { }

  ngOnInit() {

  }


  closeModal(){
    if(this.ModalService.urlRedirect!= ""){

  this.router.navigate([this.ModalService.urlRedirect]);
    }
    this.ModalService.isVisible = false;
  }

}
